export function canCache(map) {
    if (map.$granted) {
        return false;
    }
    return (map.$all ? canCache(map.$all) : true) && (map.$any ? canCache(map.$any) : true);
}
export function cacheKey(path) {
    if (!path) {
        // Root
        return "*";
    }
    let key = String(path.key);
    let current = path.prev;
    while (current) {
        key = `${current.key}.${key}`;
        current = current.prev;
    }
    return key;
}
export function isObjectOrInterface(fieldConfig) {
    return (fieldConfig.graphqlKind === "Interface" || fieldConfig.graphqlKind === "Object") && fieldConfig.kind !== "Query" && fieldConfig.kind !== "Mutation" && fieldConfig.kind !== "Subscription";
}
//# sourceMappingURL=util.js.map
